<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{roleid == 23 ? "Market Manager" : "Market Manager"}} / ສິນຄ້າແນະນຳ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 23 || roleid == 24">
        <b-tab-item label="ລາຍການຕະຫຼາດ" v-if="roleid == 23">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="20%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="30%">
                        ສະຖານທີ່
                      </th>
                      <th class="has-text-left " width="20%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketList" :key="data.MARKETID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }} {{ data.DISTRICT }} {{ data.VILLAGE }}
                      </td>
                     
                      

                      <td class="has-text-left" >
                      
                            <b-button v-if="data.ISEQUIPMENT==0"
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                opendDetailTab(data.MARKETID,data.MARKETNAME,data.ISEQUIPMENT, 1)
                              "
                              >ຜັກ-ໝາກໄມ້-ຊີ້ນ-ປາ-ເຄື່ອງປຸງ
                            </b-button>
                       
                            <b-button v-if="data.ISEQUIPMENT==1"
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                opendDetailTab(data.MARKETID,data.MARKETNAME,data.ISEQUIPMENT, 2)
                              "
                              >ອຸປະກອນ-ຫົວອາຫານ-ແນວພັນ-ວັກຊີນ
                            </b-button>
                          
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຜັກ-ໝາກໄມ້-ຊີ້ນ-ປາ-ເຄື່ອງປຸງ">
          <div class="columns scrollme" v-if="isEquipment==0">
            <div class="column">
              <b-field :label="selectedMarketName">
                <div class="columns">
                  <div class="column">
                      <table 
                      class="table is-fullwidth "
                    >
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">#</th>
                          <th class="has-text-left " width="20%">
                            ລະຫັດ
                          </th>
                          <th class="has-text-left " width="50%">
                            ສິນຄ້າ
                          </th>
                          <th class="has-text-left " width="25%">
                            ຈັດການ
                          </th>                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in productList"
                          :key="data.PRODUCTID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>
                          <td>
                            {{ data.PRODUCTID}} 
                          </td>
                          <td>
                            {{ data.PRODUCTNAME }}
                          </td>
                          <td>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                recomendProduct(1, data.PRODUCTID)
                              "
                              >+ ເພີ່ມສິນຄ້າ
                            </b-button>
                          </td>
                          
                          
                        </tr>
                      </tbody>
                    </table>              
                  </div>
                  <div class="column">
                      <b-field label="ຜັກ-ໝາກໄມ້-ຊີ້ນ-ປາ-ເຄື່ອງປຸງ">
                        <table 
                          class="table is-fullwidth "
                        >
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="5%">#</th>
                              <th class="has-text-left " width="20%">
                                ລະຫັດ
                              </th>
                              <th class="has-text-left " width="50%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-left " width="25%">
                                ຈັດການ
                              </th>                        
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in recomendProductList"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>
                              <td>
                                {{ data.PRODUCTID}} 
                              </td>
                              <td>
                                {{ data.PRODUCTNAME }}
                              </td>
                              <td>
                                <b-button
                                  class="btn-group-margin"
                                  type="is-danger"
                                  size="is-small"
                                  @click="
                                    removeRecomendProduct(data.ID)
                                  "
                                  > - ລືບສິນຄ້າ
                                </b-button>
                              </td>
                              
                              
                            </tr>
                          </tbody>
                        </table> 
                      </b-field>
                  </div>
                </div>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ອຸປະກອນ-ຫົວອາຫານ-ແນວພັນ-ວັກຊີນ">
          <div class="columns scrollme" v-if="isEquipment==1">
            <div class="column">
              <b-field :label="selectedMarketName">
                <div class="columns">
                  <div class="column">
                      <table 
                      class="table is-fullwidth "
                    >
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">#</th>
                          <th class="has-text-left " width="20%">
                            ລະຫັດ
                          </th>
                          <th class="has-text-left " width="50%">
                            ສິນຄ້າ
                          </th>
                          <th class="has-text-left " width="25%">
                            ຈັດການ
                          </th>                        
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in productList"
                          :key="data.PRODUCTID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>
                          <td>
                            {{ data.PRODUCTID}} 
                          </td>
                          <td>
                            {{ data.PRODUCTNAME }}
                          </td>
                          <td>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                recomendProduct(2, data.PRODUCTID)
                              "
                              >+ ເພີ່ມສິນຄ້າ
                            </b-button>
                          </td>
                          
                          
                        </tr>
                      </tbody>
                    </table>              
                  </div>
                  <div class="column">
                      <b-field label="ອຸປະກອນ-ຫົວອາຫານ-ແນວພັນ-ວັກຊີນ">
                        <table 
                          class="table is-fullwidth "
                        >
                          <thead>
                            <tr>
                              <th class="has-text-centered " width="5%">#</th>
                              <th class="has-text-left " width="20%">
                                ລະຫັດ
                              </th>
                              <th class="has-text-left " width="50%">
                                ສິນຄ້າ
                              </th>
                              <th class="has-text-left " width="25%">
                                ຈັດການ
                              </th>                        
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, index) in bestSellProductList"
                              :key="data.ID"
                            >
                              <td class="has-text-centered">{{ index + 1 }}</td>
                              <td>
                                {{ data.PRODUCTID}} 
                              </td>
                              <td>
                                {{ data.PRODUCTNAME }}
                              </td>
                              <td>
                                <b-button
                                  class="btn-group-margin"
                                  type="is-danger"
                                  size="is-small"
                                  @click="
                                    removeRecomendProduct(data.ID)
                                  "
                                  > - ລືບສິນຄ້າ
                                </b-button>
                              </td>
                              
                              
                            </tr>
                          </tbody>
                        </table> 
                      </b-field>
                  </div>
                </div>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activeTab:0 ,
      marketList: [],      

      selectedMarketID: null,
      selectedMarketName: null,
      marketFarmerList:[],
      selectedSelldate: null,
      selectedMarketName_selecteddate: null,

      marketSellBillDetail: [],
      marketSellBillDetailDate: [],

      productList: [],
      productAmount: 0,
      recomendProductList: [],
      bestSellProductList: [],
      isEquipment: null,

      

    };
  },
  methods: {
    getMarketRecommend() {
      RestAPI.getMarketRecommend()
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          this.marketList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    opendDetailTab(MARKETID, MARKETNAME,EQUIPMENT, Tab){
      this.isEquipment = EQUIPMENT;
      this.selectedMarketID = MARKETID;
      this.selectedMarketName = MARKETNAME;
      this.activeTab = Tab; 
      this.getMarketProducts(MARKETID)
      this.getRecomendProduct(MARKETID);
    },

    getMarketProducts(marketid) {
      // console.log("this.userProvinceID: " + this.userProvinceID)
      RestAPI.getMarketProducts(marketid)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    recomendProduct(type,productid){
        var params = {
          productid: productid,
          marketid: this.selectedMarketID,
          type: type,
          amount: type == 1 ? 0 : this.productAmount,
          username: this.username
        };
        console.log("params: ", JSON.stringify(params))
        RestAPI.recomendProduct(params)
          .then(() => {

            this.getMarketProducts(this.selectedMarketID);
            this.getRecomendProduct(this.selectedMarketID);
            // this.activeTab = 1;
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      
    },
    getRecomendProduct(marketid){
       RestAPI.getRecomendProduct(marketid)
        .then(res => {
          // console.log("recomendProductList:"+ JSON.stringify(res.data))
          this.recomendProductList = res.data.recommendproduct;
          this.bestSellProductList = res.data.bestsellproduct;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    removeRecomendProduct(ID){
        var params = {
          id: ID,
          username: this.username
        };
        // console.log("params: ", JSON.stringify(params))
        RestAPI.removeRecomendProduct(params)
          .then(() => {

            this.getMarketProducts(this.selectedMarketID);
            this.getRecomendProduct(this.selectedMarketID);
            // this.activeTab = 1;
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      
    },

    
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
   
    this.selectedMarketID =  this.user.ROLEID == 11 ? null : this.user.MARKETID;
    this.selectedMarketName =  this.user.ROLEID == 11 ? null : this.user.MARKETNAME;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID ? this.user.BRANCHPROVNICEID : 'all';
    this.selecteddate = new Date();
    this.formdate = new Date();
    this.getMarketRecommend();
   
  
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
